import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=05596bd5&"
import script from "./Query.vue?vue&type=script&lang=js&"
export * from "./Query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Query.vue"
export default component.exports